import { Outlet } from 'react-router-dom';
import SafePage from '../pages/SafePage';

export default function VaultLayout(): JSX.Element {
  return (
    <div className="flex h-full flex-col">
      <div className="flex flex-1 min-h-0">
        <div className="w-[340px] flex-shrink-0 border-r border-hbs-border bg-hbs-bg overflow-y-auto">
          <SafePage />
        </div>
        <div className="flex-1 overflow-y-auto bg-hbs-bg">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
